import { getUserAgent } from 'react-native-device-info';
import { getPlatformHeaderValue, isWeb } from 'shared/constants/platform';
import { displayVersion } from 'shared/utils/appVersionUtils';

export const getLambdaHeaders = async (
  token?: string,
  xVaroSession: string = '',
  xVaroUsage: string = '',
  customHeaders: Record<string, string> = {},
) => {
  const agent = await getUserAgent();

  const defaultHeaders = {
    'Content-Type': 'application/json',
    'X-Varo-Authversion': '2.2.0',
    'X-Varo-Platform': getPlatformHeaderValue(),
  };

  const authHeaders: Record<string, string | undefined> = {
    'x-varo-session': xVaroSession,
  };

  if (token) {
    authHeaders.Authorization = `Bearer ${token}`;
  }

  authHeaders['x-varo-client-version'] = displayVersion;
  authHeaders['x-varo-tz-offset'] = new Date().getTimezoneOffset().toString();
  authHeaders['x-varo-usage'] = xVaroUsage ?? undefined;

  if (!isWeb) {
    authHeaders['user-agent'] = agent; // This is added by default on Web
  }

  let headers = {
    ...defaultHeaders,
    ...authHeaders,
  };

  headers = {
    ...headers,
    ...customHeaders,
  };

  return headers;
};
